import React, { Component } from "react";
import Modal from "react-responsive-modal";
import StatusSection from "../component/StatusSection";
import ActionSection from "../component/ActionSection";
import StatusIcon from "../component/StatusIcon";
import ActionButton from "../component/ActionButton";
//import MainActionButton from "../component/MainActionButton";
//import FaBriefcase from "react-icons/lib/fa/briefcase";
import { Bar } from "react-chartjs-2";
import user from "../assets/image/owner.png";

const colors = {
  inactive: "",
  active: "white",
  done: "#45c926",
  failed: "#ff0000"
};

const statusIconStyle = {
  maxWidth: "25px",
  maxHeight: "25px",
  width: "auto",
  height: "auto"
};

const barOptions = {
  scales: {
    xAxes: [
      {
        stacked: true,
        gridLines: {
          color: "rgba(255,255,255,1)"
        },
        barPercentage: 0.4,
        ticks: {
          fontColor: "white"
        }
      }
    ],
    yAxes: [
      {
        stacked: true,
        gridLines: {
          color: "rgba(255,255,255,1)"
        },
        ticks: {
          fontColor: "white",
          stepSize: 500,
          callback: function(label, index, labels) {
            return label + "€";
          }
        }
      }
    ]
  },
  legend: {
    display: false
  },
  tooltips: {
    callbacks: {
      label: function(tooltipItem) {
        return tooltipItem.yLabel;
      }
    }
  }
};

export default class SecondCaseFileScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      phase: 0,
      checked: false,
      dataBar: {
        labels: ["2016", "2017", "2018"],
        backgroundColor: "#0000",
        color: "white",
        datasets: [
          {
            data: [1023, 500, 1539],
            backgroundColor: ["#004fff", "#004fff", "#004fff"]
          },
          {
            data: [1500, 700, 1563],
            backgroundColor: ["#004fff55", "#004fff55", "#004fff55"]
          },
          {
            data: [150, 563, 700],
            backgroundColor: ["#00C853", "#00C853", "#00C853"]
          },
          {
            data: [300, 0, 700],
            backgroundColor: ["#00C85355", "#00C85355", "#00C85355"]
          },
          {
            backgroundColor: ["#76FF03", "#76FF03", "#76FF03"],
            data: [250, 300, 258]
          },
          {
            backgroundColor: ["#76FF0355", "#76FF0355", "#76FF0355"],
            data: [1000, 350, 300]
          }
        ]
      }
    };
  }

  finishModal() {
    this.props.addEntry();
    this.setState({ modal: false, phase: 1 });
  }

  renderState(cCase) {
    if (this.state.phase === 0) {
      return cCase.state;
    } else {
      return "Übergeben";
    }
  }

  renderAction() {
    if (this.state.phase === 0) {
      return (
        <ActionSection>
          <ActionButton
            text="Anordnung erteilen"
            recommended={true}
            fat={true}
            action={() => this.setState({ modal: true })}
          />
          {/* <ActionButton text="Einzahlen" action={()=>{}}/> */}
          <div
            style={{
              width: 70,
              height: "auto",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid white",
              color: "white",
              padding: 5,
              float: "right"
            }}
          >
            <p style={{ color: "white", fontSize: "12px", marginLeft: 10 }}>
              Weitere
            </p>
            <img
              src={require("../assets/icon/keyboard-right-arrow-button.png")}
              style={{ maxWidth: 10, maxHeight: 10, marginLeft: 5 }}
              alt="ranim"
            />
          </div>
        </ActionSection>
      );
    } else {
      return (
        <ActionSection>
          <ActionButton
            recommended={true}
            text="Storno"
            action={() => {
              this.props.delete();
            }}
          />
          <ActionButton recommended={true} text="Einzahlen" action={() => {}} />
          <div
            style={{
              width: 70,
              height: "auto",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid white",
              color: "white",
              padding: 5,
              float: "right"
            }}
          >
            <p style={{ color: "white", fontSize: "12px", marginLeft: 10 }}>
              Weitere
            </p>
            <img
              src={require("../assets/icon/keyboard-right-arrow-button.png")}
              style={{ maxWidth: 10, maxHeight: 10, marginLeft: 5 }}
              alt="raim"
            />
          </div>
        </ActionSection>
      );
    }
  }

  renderStatus() {
    if (this.state.phase === 0) {
      return (
        <StatusSection>
          <StatusIcon
            key={"1"}
            src={require("../assets/icon/Wallet.png")}
            style={statusIconStyle}
            doneColor={colors.done}
            activeColor="white"
            status="done"
            hasBar={true}
            name="fachlich richtig"
          />
          <StatusIcon
            key={"2"}
            src={require("../assets/icon/Wallet.png")}
            style={statusIconStyle}
            doneColor={colors.done}
            activeColor="white"
            status="done"
            hasBar={true}
            name="sachlich richtig"
          />
          <StatusIcon
            key={"3"}
            src={require("../assets/icon/Briefcase.png")}
            style={statusIconStyle}
            doneColor={colors.done}
            activeColor="white"
            status="active"
            hasBar={true}
            name="Rechnung richtig"
          />
          <StatusIcon
            key={"4"}
            src={require("../assets/icon/Hand Shake.png")}
            style={statusIconStyle}
            doneColor={colors.done}
            activeColor="white"
            hasBar={true}
            name="Anordnung"
          />
          <StatusIcon
            key={"5"}
            src={require("../assets/icon/Combined Shape.png")}
            style={statusIconStyle}
            doneColor={colors.done}
            activeColor="white"
            hasBar={false}
            name="Abgeschlossen"
          />
        </StatusSection>
      );
    } else {
      return (
        <StatusSection>
          <StatusIcon
            key={"1"}
            src={require("../assets/icon/Wallet.png")}
            style={statusIconStyle}
            doneColor={colors.failed}
            activeColor="white"
            status="done"
            hasBar={true}
            name="fachlich richtig"
          />
          <StatusIcon
            key={"2"}
            src={require("../assets/icon/Wallet.png")}
            style={statusIconStyle}
            doneColor={colors.failed}
            activeColor="white"
            status="done"
            hasBar={true}
            name="sachlich richtig"
          />
          <StatusIcon
            key={"3"}
            src={require("../assets/icon/Briefcase.png")}
            style={statusIconStyle}
            doneColor={colors.active}
            activeColor="white"
            status="done"
            hasBar={true}
            name="Rechnung richtig"
          />
          <StatusIcon
            key={"4"}
            src={require("../assets/icon/Hand Shake.png")}
            style={statusIconStyle}
            doneColor={colors.done}
            activeColor={colors.done}
            status="active"
            hasBar={true}
            name="Anordnung"
          />
          <StatusIcon
            key={"5"}
            src={require("../assets/icon/Combined Shape.png")}
            style={statusIconStyle}
            doneColor={colors.done}
            activeColor="white"
            hasBar={false}
            name="Abgeschlossen"
          />
        </StatusSection>
      );
    }
  }

  renderConfirmedSign(name, state) {
    switch (state) {
      case -1:
        return <p className="disconfirmed">{name + " ✖"}</p>;
      case 0:
        return <p className="uncomfirmed">{name + " ?"}</p>;
      case 1:
        return <p className="confirmed">{name + " ✔"}</p>;
      default:
        return null;
    }
  }

  renderBeleg(beleg, index) {
    return (
      <tr>
        <td>{index + 1}</td>
        <td> {beleg.name}</td>
        <td> {beleg.due}</td>
        <td>{beleg.money + "€"}</td>
        <td>›</td>
      </tr>
    );
  }

  renderLog(log, index) {
    return (
      <tr>
        <td> {log.date} </td>
        <td> {log.status} </td>
        <td> {log.state}</td>
        <td> {log.worker} </td>
        <td> {log.action} </td>
        <td> {log.money + "€"} </td>
        <td>
          {" "}
          {log.change} <br />
          {log.change !== "•" ? <i class="arrow down"></i> : null}
        </td>
      </tr>
    );
  }

  renderModal() {
    let value =
      `Sehr geehrte Damen und Herren,

wir übergeben Ihnen folgende Forderung:

Name: ` +
      this.props.case.name.value +
      `
Adresse: ` +
      this.props.case.address.value +
      `
Vertragskonto: ` +
      this.props.case.id +
      `
Hauptforderung: ` +
      this.props.case.stats.inkasso.value +
      `,00€
Mahngebühren: ` +
      this.props.case.stats.fee.value +
      `,00€
Zinsen: ` +
      this.props.case.stats.zinsen.value +
      `,00€

Freundliche Grüße
M. Müller
BKW Energie AG`;
    return (
      <Modal
        open={this.state.modal}
        onClose={() => this.setState({ modal: false })}
        center
      >
        <div style={{ margin: "30px" }}>
          <p style={{ marginBottom: "10px", marginTop: "-10px" }}>
            {"Email senden an Crefo"}
          </p>
          <textarea
            style={{ padding: "10px" }}
            rows="15"
            cols="100"
            defaultValue={value}
          />
          <div>
            <span>
              <input
                style={{
                  height: "initial",
                  width: "initial",
                  float: "left",
                  paddingTop: "11px"
                }}
                type="checkbox"
                onChange={event =>
                  this.setState({ checked: event.target.checked })
                }
              />
              <p style={{ float: "left", fontSize: "13px", paddingTop: "8px" }}>
                Abgabe bestätigen
              </p>
            </span>
            <button
              style={{
                float: "right",
                padding: "8px",
                color: "#0E4BCE",
                border: "0px",
                fontSize: "13px"
              }}
              onClick={() => this.finishModal()}
              disabled={!this.state.checked}
            >
              Abgabe an Andere
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  render() {
    let cCase = this.props.case;
    return (
      <div className="">
        <div className="gpPart">
          <div className="gpProfile">
            <img src={user} alt="user" />
            <div className="mdLeftBlock">
              <span>
                {this.renderConfirmedSign("Name", cCase.name.confirmed)}
                <p>{cCase.name.value}</p>
                <p>{"Vertreten durch: " + cCase.contact}</p>
              </span>
              <span>
                {this.renderConfirmedSign("Adresse", cCase.address.confirmed)}
                <p>{cCase.address.value}</p>
              </span>
            </div>

            <div className="mdLeftBlock">
              <span>
                {this.renderConfirmedSign("Email", cCase.email.confirmed)}
                <p>{cCase.email.value}</p>
              </span>
              <span>
                {this.renderConfirmedSign("Telefon", cCase.phone.confirmed)}
                <p>{cCase.phone.value}</p>
              </span>
            </div>

            <div className="mdRightBlock">
              <span>
                {this.renderConfirmedSign("Mobil", cCase.mobile.confirmed)}
                <p>{cCase.mobile.value}</p>
              </span>
              <span>
                {this.renderConfirmedSign("Fax", cCase.fax.confirmed)}
                <p>{cCase.fax.value}</p>
              </span>
            </div>
          </div>

          <hr />

          <p className="heading">F&auml;lle | 2</p>
          <div className="kind gpcases active">
            <p>
              <i>Status</i>
              <br />
              {this.state.phase === 0 ? "fachlich richtig" : "Crefo"}
            </p>

            <p>
              <i>Bearbeitungszustand</i>
              <br />
              {this.state.phase === 0 ? cCase.state : "Übergeben"}
            </p>

            <p>
              <i>Belege</i>
              <br />
              {cCase.belege.length}
            </p>

            <p>
              <i>Gesamtbetrag</i>
              <br />
              {cCase.stats.total.value + "€"}
            </p>
            <p>›</p>
          </div>

          <div className="kind gpcases">
            <p>
              <i>Status</i>
              <br />
              fachlich richtig
            </p>

            <p>
              <i>Bearbeitungszustand</i>
              <br />
              Rechnungsbestätigung
            </p>

            <p>
              <i>Belege</i>
              <br />5
            </p>

            <p>
              <i>Gesamtbetrag</i>
              <br />
              3.579 €
            </p>
            <p>›</p>
          </div>
          <div className="scfcStastic">
            <div>
              <p>
                <i>Anzahl Akten</i>
                <br />2
              </p>
            </div>

            <div>
              <p>
                <i>DSO</i>
                <br />5 Tage
              </p>
            </div>

            <div>
              <p>
                <i>Gesamtbetrag</i>
                <br />
                9.540 €
              </p>
            </div>

            <div>
              <p>
                <i>Einzahlungen</i>
                <br />
                1.135 €
              </p>
            </div>

            <div>
              <p>
                <i>Erüllungsqoute</i>
                <br />
                83 %
              </p>
            </div>
          </div>
          <hr />
          <p className="heading">Mittelr&uuml;ckfluss | 3 Jahre</p>
          <div style={{ width: "100%", height: "auto", marginTop: "30px" }}>
            <Bar
              data={this.state.dataBar}
              width={80}
              height={17}
              options={barOptions}
              color="white"
              ref="bar"
            />
          </div>
        </div>

        <div className="caseContainerTemp scfcContainer">
          <div className="casepart">
            <div className="caseHeader">
              <p>
                <i>Rechnung </i>
                {cCase.id}
              </p>
              <p>
                <i>Anzahl Akten</i> 2
              </p>
              <p>
                <i>Verantwortlicher</i> M. Müller{" "}
              </p>
              {/* <span>{cCase.overdue + ' Tage überfällig'}</span> */}
              <p>{cCase.overdue + " Tage überfällig"}</p>
              <br />

              <p>
                <i>Bearbeitungszustand</i> {this.renderState(cCase)}
              </p>
            </div>
            <div
              className="importantNav"
              style={{
                width: "100%",
                height: "30",
                display: "block",
                paddingTop: 5,
                marginTop: 10,
                marginBottom: 10,
                alignItems: "center"
              }}
            ></div>

            <div
              className="caseState"
              style={{ alignItems: "center", marginTop: 5 }}
            >
              {this.renderStatus()}

              <div className="actionSection" style={{ paddingTop: 5 }}>
                {this.renderAction()}
              </div>
            </div>

            <hr />

            <div className="sum">
              <span>
                <p>{cCase.stats.inkasso.perc + "%"}</p>
                <p>{cCase.stats.inkasso.value + "€"}</p>
                <p>Inkasso</p>
              </span>
              <span>+</span>
              <span>
                <p>{cCase.stats.fee.perc + "%"}</p>
                <p>{cCase.stats.fee.value + "€"}</p>
                <p>Geb&uuml;hr</p>
              </span>
              <span>+</span>
              <span>
                <p>{cCase.stats.zinsen.perc + "%"}</p>
                <p>{cCase.stats.zinsen.value + "€"}</p>
                <p>Zinsen</p>
              </span>
              <div className="routineScreenVerticalLine"></div>
              <span>
                <p>{cCase.stats.total.perc + "%"}</p>
                <p>{cCase.stats.total.value + "€"}</p>
                <p>Gesamtbetrag</p>
              </span>
            </div>

            <div className="logs receipts">
              <p>Logbuch | 2</p>
              <div style={{ overflowY: "scroll", height: "200px" }}>
                <table>
                  <thead>
                    <tr>
                      <td> Datum </td>
                      <td> Status </td>
                      <td> Bearbeitungszustand</td>
                      <td> Mitarbeiter </td>
                      <td> Aktion </td>
                      <td> Gesamtbetrag </td>
                      <td>&nbsp;</td>
                    </tr>
                  </thead>
                  <tbody>
                    {cCase.logs.map((v, i) => {
                      return this.renderLog(v, i);
                    })}
                    {/* <tr>
                      <td> 25.02.2018 </td>
                      <td> fachlich richtig </td>
                      <td>Rechnungsbestätigung</td>
                      <td> M. Müller </td>
                      <td> Email </td>
                      <td> 3.900 € </td>
                      <td> 300 <br/><i class="arrow down"></i></td>
                  </tr>
                    <tr>
                      <td> 01.02.2018 </td>
                      <td> Erst Buchung </td>
                      <td> fachlich richtig</td>
                      <td> M. Müller </td>
                      <td> Angelegt </td>
                      <td> 4.200 € </td>
                      <td>•</td>
                  </tr> */}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="receipts">
              <p>{"Belege | " + cCase.belege.length}</p>
              <div className="receiptsTable">
                <table>
                  <thead>
                    <tr>
                      <td> Nr.</td>
                      <td> Belegname </td>
                      <td> Datum</td>
                      <td> Summe </td>
                      <td>&nbsp;</td>
                    </tr>
                  </thead>
                  <tbody>
                    {cCase.belege.map((v, i) => {
                      return this.renderBeleg(v, i);
                    })}
                  </tbody>
                </table>
              </div>
              <div className="tableNotes">
                <p>Notizen</p>
                <br />
                <p>{cCase.notes[0].date}</p>
                <p>{cCase.notes[0].value}</p>
              </div>
            </div>
          </div>
          {/* <div>
          <button onClick={() => this.props.close()}>Close</button>
          <button onClick={() => this.props.delete()}>Delete</button>
          <button onClick={() => this.setState({modal: true})}>Abgeben an Andere</button>
        </div> */}
          {this.renderModal()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/SecondCaseFileScreen.js